<header [ngClass]="{'insurance-menu-header': isInsuranceMenuOpen}">
  <div class="left-header">
    <iris-icon-button
      *ngIf="isInsuranceMenuOpen"
      (click)="returnToMoreFilters()"
      icon="arrow_back"
      ariaLabel="return to filter list"
      [type]="tertiaryIrisIconButtonType"
    ></iris-icon-button>
    <h3 class="menu-label">{{ isInsuranceMenuOpen ? "My insurance" : "More filters" }}</h3>
  </div>
  <iris-icon-button
    (click)="cancel()"
    id="close-modal-button"
    icon="close"
    ariaLabel="close menu button"
    [type]="tertiaryIrisIconButtonType"
  ></iris-icon-button>
</header>
<main *ngIf="!isInsuranceMenuOpen; else insuranceMenu">
  <section role="listbox">
    <h4 class="category-label">
      My Insurance
    </h4>
    <ng-container *ngIf="!isLoadingNewInsuranceOptions; else loader">
      <ng-container *ngFor="let option of noInsuranceOptions; let i = index">
        <div
          class="filter-select-list-item"
          [ngClass]="{'selected': insuranceControl.value && insuranceControl.value.pncId == option.value.pncId}"
          (mousedown)="$event.preventDefault()"
          (click)="updateInsuranceValue(option.value)"
          (keydown)="handleInsuranceKeyDown($event, option.value)"
          [attr.aria-selected]="insuranceControl.value == option.value"
          [attr.aria-label]="option.name || 'Empty'"
          role="option"
          tabindex="0"
        >
          <span class="filter-select-list-item-label">{{ option.name }}</span>
        </div>
      </ng-container>
      <button
        *ngIf="isAnyHealthInsuranceOptions"
        (click)="showHealthInsuranceSubMenu()"
        class="filter-select-list-item insurance-sub-menu"
        [ngClass]="{'selected': isHealthInsuranceOptionSelected}"
        aria-label="View health insurance plans"
      >
        Health insurances
        <iris-icon 
          name="arrow_forward" 
          [color]="iconColor" 
          [size]="iconSize"
        >
        </iris-icon>
      </button>
      <button
        *ngIf="isAnyMedicareOptions"
        (click)="showMedicareSubMenu()"
        class="filter-select-list-item insurance-sub-menu"
        [ngClass]="{'selected': isMedicareOptionSelected}"
        aria-label="View Medicare insurance plans"
      >
        Medicare plans
        <iris-icon 
          name="arrow_forward" 
          [color]="iconColor" 
          [size]="iconSize"
        >
        </iris-icon>
      </button>
      <button
        *ngIf="isAnyEapOptions"
        (click)="showEapSubMenu()"
        class="filter-select-list-item insurance-sub-menu"
        [ngClass]="{'selected': isEapOptionSelected}"
        aria-label="View EAP Employee Assistance Program insurance plans"
      >
        (EAP) Employee Assistance Programs
        <iris-icon 
          name="arrow_forward" 
          [color]="iconColor" 
          [size]="iconSize"
        >
        </iris-icon>
      </button>
      <button
        class="show-more-button"
        (click)="showFullInsuranceMenu()"
      >
        Show all
      </button>
    </ng-container>
  </section>
  <section role="listbox">
    <h4 class="category-label">Provider gender</h4>
    <div
      *ngFor="let option of genderOptions; let i = index"
      class="filter-select-list-item"
      [ngClass]="{'selected': option.value && (genderControl.value | isOptionSelected:option.value)}"
      [id]="'gender-option-' + i"
      (mousedown)="$event.preventDefault()"
      (click)="updateGenderValue(option.value)"
      (mouseenter)="onHoverEnter(option.value.toString())"
      (mouseleave)="onHoverLeave()"
      (keydown)="handleGenderKeyDown($event, option.value)"
      [attr.aria-selected]="(genderControl.value | isOptionSelected:option.value)"
      [attr.aria-label]="option.name"
      role="option"
      tabindex="0"
    >
      <div class="iris-checkbox">
        <div
          class="iris-checkbox-highlight-circle"
          [ngClass]="{'show-highlight': currentHoveredValue === option.value.toString()}"
        ></div>
        <div
          class="iris-checkbox-box"
          [ngClass]="{
            'is-checked': option.value && (genderControl.value | isOptionSelected:option.value),
            'is-highlighted': currentHoveredValue === option.value.toString()
          }"
        >
          <div class="iris-checkmark" >
            <div class="iris-checkmark-right iris-checkmark-half"></div>
            <div class="iris-checkmark-left iris-checkmark-half"></div>
          </div>
        </div>
      </div>
      <span class="filter-select-list-item-label">{{ option.name }}</span>
    </div>
  </section>
  <section role="listbox">
    <h4 class="category-label">My location</h4>
    <div
      *ngFor="let option of locationOptions; let i = index"
      [id]="'location-option-' + i"
      class="filter-select-list-item"
      [ngClass]="{'selected': option.value && locationControl.value == option.value}"
      (mousedown)="$event.preventDefault()"
      (click)="updateLocationValue(option.value)"
      (keydown)="handleLocationKeyDown($event, option.value)"
      [attr.aria-selected]="locationControl.value == option.value"
      [attr.aria-label]="option.name || 'Empty'"
      role="option"
      tabindex="0"
    >
      <span class="filter-select-list-item-label">{{ option.name }}</span>
    </div>
  </section>
</main>
<footer>
  <iris-button
    [type]="tertiaryIrisButtonType"
    [disabled]="!isAnyValueSelected"
    [typeAttribute]="resetButtonType"
    (click)="resetValues(isInsuranceMenuOpen)"
  >
    Clear selection
  </iris-button>
  <iris-button
    [type]="primaryIrisButtonType"
    [typeAttribute]="submitButtonType"
    (click)="confirm()"
  >
    See results
  </iris-button>
</footer>

<ng-template #insuranceMenu>
  <main class="insurance-menu">
    <ng-container *ngFor="let category of insuranceCategorizedOptionsToDisplay">
      <section *ngIf="category.options.length > 0" role="listbox">
        <h4 *ngIf="category.name" class="category-label">
          {{ category.name }}
        </h4>
        <div
          *ngFor="let option of category.options; let i = index"
          class="filter-select-list-item"
          [ngClass]="{'selected': option.value && insuranceControl.value == option.value}"
          (mousedown)="$event.preventDefault()"
          (click)="updateInsuranceValue(option.value)"
          (keydown)="handleInsuranceKeyDown($event, option.value)"
          [attr.aria-selected]="insuranceControl.value == option.value"
          [attr.aria-label]="option.name || 'Empty'"
          role="option"
          tabindex="0"
        >
          <span class="filter-select-list-item-label">{{ option.name }}</span>
        </div>
      </section>
    </ng-container>
  </main>
</ng-template>

<ng-template #loader>
  <div class="loader"></div>
</ng-template>
